import http from './http'
export default class IncludeApi {
    static getKeywords(params) {
        return http.httpGet('keywords', params);
    }
    static getKeywordsList(params) {
        return http.httpGet('keywords/list', params);
    }
    static getStatistics(params) {
        return http.httpGet('keywords/statistics', params);
    }

    static downloadExcel(id,time) {
        return http.getBaseUrl() + '/keywords/download?uid=' + id+'&t='+time;
    }
}



// WEBPACK FOOTER //
// ./app/api/keywords.api.js